import DayLineChart from './charts/DayLineChart';
import { Layout, Row, Col, Card, Select, Button } from 'antd'; // Import's Ant Design 
import React, { useState, useEffect } from 'react'; // Import's React 
import { useHistory } from 'react-router-dom'; // Import's React Router Dom

const { Content, Header } = Layout // Destructuring Layout

export function days(m, y) {
  return new Date(y, m, 0).getDate();
}

const DayStatistics = (props) => {

  const value = props.location.params;
  const navigate = useHistory();

  let month;
  let monthText;
  let title;
  let year = 2022;
  let labels = [];
  let daysInt = 0;

  switch (value) {
    case 'enero_ht':
      month = 1;
      monthText = "Enero";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'enero_hm':
      month = 1;
      monthText = "Enero";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'enero_he':
      month = 1;
      monthText = "Enero";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'enero_kt':
      month = 1;
      monthText = "Enero";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'enero_km':
      month = 1;
      monthText = "Enero";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'enero_ke':
      month = 1;
      monthText = "Enero";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'febrero_ht':
      month = 2;
      monthText = "Febrero";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'febrero_hm':
      month = 2;
      monthText = "Febrero";
      title = "Honda Mexicali";
      daysInt = days(month, year);
      break;

    case 'febrero_he':
      month = 2;
      monthText = "Febrero";
      title = "Honda Ensenada";
      daysInt = days(month, year);
      break;

    case 'febrero_kt':
      month = 2;
      monthText = "Febrero";
      title = "Kia Tijuana";
      daysInt = days(month, year);
      break;

    case 'febrero_km':
      month = 2;
      monthText = "Febrero";
      title = "Kia Mexicali";
      daysInt = days(month, year);
      break;

    case 'febrero_ke':
      month = 2;
      monthText = "Febrero";
      title = "Kia Ensenada";
      daysInt = days(month, year);
      break;

    case 'marzo_ht':
      month = 3;
      monthText = "Marzo";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'marzo_hm':
      month = 3;
      monthText = "Marzo";
      title = "Honda Mexicali";
      daysInt = days(month, year);
      break;

    case 'marzo_he':
      month = 3;
      monthText = "Marzo";
      title = "Honda Ensenada";
      daysInt = days(month, year);
      break;

    case 'marzo_kt':
      month = 3;
      monthText = "Marzo";
      title = "Kia Tijuana";
      daysInt = days(month, year);
      break;

    case 'marzo_km':
      month = 3;
      monthText = "Marzo";
      title = "Kia Mexicali";
      daysInt = days(month, year);
      break;

    case 'marzo_ke':
      month = 3;
      monthText = "Marzo";
      title = "Kia Ensenada";
      daysInt = days(month, year);
      break;

    case 'abril_ht':
      month = 4;
      monthText = "Abril";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'abril_hm':
      month = 4;
      monthText = "Abril";
      title = "Honda Mexicali";
      daysInt = days(month, year);
      break;

    case 'abril_he':
      month = 4;
      monthText = "Abril";
      title = "Honda Ensenada";
      daysInt = days(month, year);
      break;

    case 'abril_kt':
      month = 4;
      monthText = "Abril";
      title = "Kia Tijuana";
      daysInt = days(month, year);
      break;

    case 'abril_km':
      month = 4;
      monthText = "Abril";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'abril_ke':
      month = 4;
      monthText = "Abril";
      title = "Kia Ensenada";
      daysInt = days(month, year);
      break;

    case 'mayo_ht':
      month = 5;
      monthText = "Mayo";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'mayo_hm':
      month = 5;
      monthText = "Mayo";
      title = "Honda Mexicali";
      daysInt = days(month, year);
      break;

    case 'mayo_he':
      month = 4;
      monthText = "Mayo";
      title = "Honda Ensenada";
      daysInt = days(month, year);
      break;

    case 'mayo_kt':
      month = 5;
      monthText = "Mayo";
      title = "Kia Tijuana";
      daysInt = days(month, year);
      break;

    case 'mayo_km':
      month = 5;
      monthText = "Mayo";
      title = "Kia Mexicali";
      daysInt = days(month, year);
      break;

    case 'mayo_ke':
      month = 5;
      monthText = "Mayo";
      title = "Kia Ensenada";
      daysInt = days(month, year);
      break;

    case 'junio_ht':
      month = 6;
      monthText = "Junio";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'junio_hm':
      month = 6;
      monthText = "Junio";
      title = "Honda Mexicali";
      daysInt = days(month, year);
      break;

    case 'junio_he':
      month = 6;
      monthText = "Junio";
      title = "Honda Ensenada";
      daysInt = days(month, year);
      break;

    case 'junio_kt':
      month = 6;
      monthText = "Junio";
      title = "Kia Tijuana";
      daysInt = days(month, year);
      break;

    case 'junio_km':
      month = 6;
      monthText = "Junio";
      title = "Kia Mexicali";
      daysInt = days(month, year);
      break;

    case 'junio_ke':
      month = 6;
      monthText = "Junio";
      title = "Kia Ensenada";
      daysInt = days(month, year);
      break;

    case 'julio_ht':
      month = 7;
      monthText = "Julio";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'julio_hm':
      month = 7;
      monthText = "Julio";
      title = "Honda Mexicali";
      daysInt = days(month, year);
      break;

    case 'julio_he':
      month = 7;
      monthText = "Julio";
      title = "Honda Ensenada";
      daysInt = days(month, year);
      break;

    case 'julio_kt':
      month = 7;
      monthText = "Julio";
      title = "Kia Tijuana";
      daysInt = days(month, year);
      break;

    case 'julio_km':
      month = 7;
      monthText = "Julio";
      title = "Kia Mexicali";
      daysInt = days(month, year);
      break;

    case 'julio_ke':
      month = 7;
      monthText = "Julio";
      title = "Kia Ensenada";
      daysInt = days(month, year);
      break;

    case 'agosto_ht':
      month = 8;
      monthText = "Agosto";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'agosto_hm':
      month = 8;
      monthText = "Agosto";
      title = "Honda Mexicali";
      daysInt = days(month, year);
      break;

    case 'agosto_he':
      month = 8;
      monthText = "Agosto";
      title = "Honda Ensenada";
      daysInt = days(month, year);
      break;

    case 'agosto_kt':
      month = 8;
      monthText = "Agosto";
      title = "Kia Tijuana";
      daysInt = days(month, year);
      break;

    case 'agosto_km':
      month = 8;
      monthText = "Agosto";
      title = "Kia Mexicali";
      daysInt = days(month, year);
      break;

    case 'agosto_ke':
      month = 8;
      monthText = "Agosto";
      title = "Kia Ensenada";
      daysInt = days(month, year);
      break;

    case 'septiembre_ht':
      month = 9;
      monthText = "Septiembre";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'septiembre_hm':
      month = 9;
      monthText = "Septiembre";
      title = "Honda Mexicali";
      daysInt = days(month, year);
      break;

    case 'septiembre_he':
      month = 9;
      monthText = "Septiembre";
      title = "Honda Ensenada";
      daysInt = days(month, year);
      break;

    case 'septiembre_kt':
      month = 9;
      monthText = "Septiembre";
      title = "Kia Tijuana";
      daysInt = days(month, year);
      break;

    case 'septiembre_km':
      month = 9;
      monthText = "Septiembre";
      title = "Kia Mexicali";
      daysInt = days(month, year);
      break;

    case 'septiembre_ke':
      month = 9;
      monthText = "Septiembre";
      title = "Kia Ensenada";
      daysInt = days(month, year);
      break;

    case 'octubre_ht':
      month = 10;
      monthText = "Octubre";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'octubre_hm':
      month = 10;
      monthText = "Octubre";
      title = "Honda Mexicali";
      daysInt = days(month, year);
      break;

    case 'octubre_he':
      month = 10;
      monthText = "Noviembre";
      title = "Honda Ensenada";
      daysInt = days(month, year);
      break;

    case 'octubre_kt':
      month = 10;
      monthText = "Octubre";
      title = "Kia Tijuana";
      daysInt = days(month, year);
      break;

    case 'octubre_km':
      month = 10;
      monthText = "Octubre";
      title = "Kia Mexicali";
      daysInt = days(month, year);
      break;

    case 'octubre_ke':
      month = 10;
      monthText = "Octubre";
      title = "Kia Ensenada";
      daysInt = days(month, year);
      break;

    case 'noviembre_ht':
      month = 11;
      monthText = "Noviembre";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'noviembre_hm':
      month = 11;
      monthText = "Noviembre";
      title = "Honda Ensenada";
      daysInt = days(month, year);
      break;

    case 'noviembre_he':
      month = 11;
      monthText = "Noviembre";
      title = "Honda Ensenada";
      daysInt = days(month, year);
      break;

    case 'noviembre_kt':
      month = 11;
      monthText = "Noviembre";
      title = "Kia Tijuana";
      daysInt = days(month, year);
      break;

    case 'noviembre_km':
      month = 11;
      monthText = "Noviembre";
      title = "Kia Mexicali";
      daysInt = days(month, year);
      break;

    case 'noviembre_ke':
      month = 11;
      monthText = "Noviembre";
      title = "Kia Ensenada";
      daysInt = days(month, year);
      break;

    case 'diciembre_ht':
      month = 12;
      monthText = "Diciembre";
      title = "Honda Tijuana";
      daysInt = days(month, year);
      break;

    case 'diciembre_hm':
      month = 12;
      monthText = "Diciembre";
      title = "Honda Mexicali";
      daysInt = days(month, year);
      break;

    case 'diciembre_he':
      month = 12;
      monthText = "Diciembre";
      title = "Honda Ensenada";
      daysInt = days(month, year);
      break;

    case 'diciembre_kt':
      month = 12;
      monthText = "Diciembre";
      title = "Kia Tijuana";
      daysInt = days(month, year);
      break;

    case 'diciembre_km':
      month = 12;
      monthText = "Diciembre";
      title = "Kia Mexicali";
      daysInt = days(month, year);
      break;

    case 'diciembre_ke':
      month = 12;
      monthText = "Diciembre";
      title = "Kia Ensenada";
      daysInt = days(month, year);
      break;

    default:
      const path = { pathname: '/test_chart/YearStatistics' }
      navigate.push(path);
      break;
  }

  console.log(daysInt);

  for (let i = 1; i <= daysInt; i++) {
    console.log(i);
    labels.push(i);
  }

  console.log(labels);

  return (
    <Content>
      {/* Header */}
      <Header
        style={{ background: 'white', width: '100%', borderRadius: '5px', marginBottom: '1.5rem', boxShadow: '5px 8px 24px 5px rgba(208, 216, 243, 0.6)' }}>
        <div
          style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '5px' }}>
          {/* Header Select */}
          <div
            style={{ width: '20%', textAlign: 'center' }}>
            <h3>{title}</h3>
          </div>
          {/* Header Año | Mes */}
          <div
            style={{ width: '20%', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '2px' }}>
            <Button
              type='primary'>Año
            </Button>
            <Button
              type='primary'>Mes
            </Button>
          </div>
          {/* Header Año */}
          <div
            style={{ width: '20%', textAlign: 'center' }}>
            Agosto 2022
          </div>
        </div>
      </Header>

      {/* Graphics */}
      <Row>
        <Col
          span={18}
          style={{ borderRadius: '5px', margin: '0 auto' }}>
          <Card
            size="small"
            title=""
            style={{
              width: '100%',
              boxShadow: '5px 8px 24px 5px rgba(208, 216, 243, 0.6)'
            }}
          >
            <DayLineChart
              monthText={monthText}
              labels={labels}
              title={title}
            />
          </Card>
        </Col>
      </Row>
    </Content>
  )
}

export default DayStatistics